module.exports = __webpack_public_path__ + "static/media/checkout-disabled.1990b708.png";